import PropTypes from 'prop-types'

import BaseLayout from '~layouts/BaseLayout'
import HelmetSEO from '~partials/global/HelmetSEO'
import NodeTypeTracker from '~partials/global/NodeTypeTracker'

const IndustryLayout = ({ children, title, description, socialMediaImage }) => (
  <BaseLayout
    footerProps={{
      hideCTA: true,
    }}
  >
    <HelmetSEO
      title={title}
      description={description}
      image={socialMediaImage}
    />
    <NodeTypeTracker nodeType="industries" />
    {children}
  </BaseLayout>
)

IndustryLayout.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  socialMediaImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default IndustryLayout
